<template>
  <div class="flow-list-item round-corner">
    <Panel
        v-if="item"
        :img="getAvatarByUUID(item.starterUUID)"
        :title="item.title"
        :tagArr="tagArr"
        :descArr="descArr"
        :btnArr="btnArr"
        :foldDesc="true"
        @btnDetailClick="btnDetailClickHandler"
        @btnDeleteClick="btnDeleteClickHandler"
    />
  </div>
</template>

<script>
import {Toast, Dialog} from 'vant'
import {formatFieldsForFlow} from '@/utils/dateTimeUtil'
import Panel from '@/components/Panel/Panel'
import {deleteInstance} from '@/api/flow'
import {getAvatarByUUID} from '@/utils/commons'
import {locationTo, complete} from "@/utils/url";

export default {
  name: 'FlowListItem',
  components: {
    Panel,
  },
  props: ['type', 'item'],
  data() {
    return {}
  },
  computed: {
    tagArr() {
      let result = {}
      switch (this.item.tStatus) {
        case 'end':
          result.text = '已办结'
          result.color = '#666'
          break;
        case 'send':
          result.text = '进行中'
          result.color = '#04be02'
          break;
        case 'finish':
          result.text = '已中止'
          result.color = '#4F4A81'
          break;
        case 'back':
          result.text = '已退回'
          result.color = '#ef4f4f'
          break;
        case 'draft':
          result.text = '草稿'
          result.color = '#deb887'
          break;
        case 'revoke':
        case 'haverevoke':
          result.text = '已撤销'
          result.color = '#947286'
          break;
      }
      return [result]
    },
    descArr() {
      let descArr = []

      // 发起人和发起时间
      descArr.push({key: '', value: `${this.item.starterName}发起于${this.item.startTime}`})

      // 操作人和操作时间
      if (this.item.lastOperName) {
        descArr.push({key: '最新操作人', value: this.item.lastOperName})
        descArr.push({key: '操作时间', value: this.item.opdate})
      }

      // 表单数据
      if (this.item.wfContent) {
        try {
          let fieldArr = JSON.parse(this.item.wfContent)
          fieldArr = formatFieldsForFlow(fieldArr)
          fieldArr.forEach(field => descArr.push({key: field.cnfield, value: field.value}))
        } catch (e) {
          console.warn(e)
        }
      }

      return descArr
    },
    btnArr() {
      let btnArr = []

      // 查看详情
      btnArr.push({text: '查看详情', event: 'btnDetailClick'})

      // 删除事项
      if (/^(ongoing|end|draft)$/.test(this.type)
          && /^(finish|revoke|haverevoke|back|draft)$/.test(this.item.tStatus)) {
        btnArr.push({text: '删除', event: 'btnDeleteClick'})
      }

      return btnArr
    },
  },
  mounted() {
  },
  methods: {
    btnDetailClickHandler() {
      //保存类型的草稿
      if (this.item.tStatus == 'draft' && this.item.tType == 'pub') {
        let index = window.location.href.lastIndexOf('draft') + 6;
        let keyText = window.location.href.substr(index);
        this.locationTo(`weixin/weui/cooperate.html#new/form/draft/${keyText}/${this.item.id}`)
      }
      //取回类型的草稿
      else if (this.item.tStatus == 'draft') {
        this.locationTo(`weixin/weui/cooperate.html#detail/${this.item.id}` + '/draft')
      } else {
        this.locationTo(`weixin/weui/cooperate.html#detail/${this.item.id}`)
      }
    },
    btnDeleteClickHandler() {
      Dialog.confirm({message: '确定要删除这个事项吗？'})
          .then(() => {
            deleteInstance(this.item.id).then(res => {
              if (res.code == 200) {
                this.$emit('deleteHandler', this.item.id)
                Toast(res.msg || '删除成功')
              } else {
                Toast(res.msg || '删除失败')
              }
            })
          })
    },
    getAvatarByUUID, locationTo, complete
  }
}
</script>

<style scoped lang="scss">
.flow-list-item {
}
</style>
